import { expValEquals } from '@confluence/feature-experiments';
import { useBooleanFeatureFlag } from '@confluence/session-data';

export enum Cohort {
	CONTROL = 'control',
	EXPERIMENT = 'experiment',
}

export const useFeedShouldHideComments = () => {
	const isFeedWithoutCommentsEnabled = useBooleanFeatureFlag(
		'confluence.frontend.feed.no-comments',
	);
	if (!isFeedWithoutCommentsEnabled) {
		return false;
	}

	if (expValEquals('confluence_feed_without_comment', 'cohort', 'experiment')) {
		return true;
	}
	return false;
};
